/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import EventDispatcher from '../../state/reducers/EventDispatcher';
import Address from './Address';
import SearchInput from '../../common/Search';
import { isEmpty } from '../../utils/object';
import configENV from '../../config';

const { PERSIST_KEY } = configENV;

class AddressList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            recipients: [],
        };
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount = () => {
        const { recipients } = this.props;
        this.setState({ recipients });
    };

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps = (props) => {
        const { recipients } = props;
        this.setState({ recipients });
    };

    handleSearchRecipientChange = (data) => {
        const { search } = data;
        const { recipients: allRecipients } = this.props;
        // console.log('search', search);
        const recipients = allRecipients.filter((r) => [
            r.FirstName,
            r.LastName,
            r.EmployerName,
            r.PhoneNumber,
            r.Addresses[0].AddressLineOne,
            r.Addresses[0].AddressLineTwo,
            r.Addresses[0].City,
        ]
            .join(' ')
            .match(new RegExp(search, 'ig')));
        // console.log('recipients', recipients);
        this.setState({ recipients });
    };

    render() {
        const {
            countries,
            recipients: allRecipients,
            handleEditRecipientClicked,
            handleRemoveRecipientClicked,
        } = this.props;

        const { recipients } = this.state;

        if (!recipients) return null;

        if (isEmpty(allRecipients)) {
            return (
                <>
                    <p className="align-center">
                        You do not have any saved addresses on file.
                    </p>
                </>
            );
        }

        return (
            <>
                <SearchInput
                    label="Search Recipient"
                    className="margin-bottom-2x"
                    onChange={this.handleSearchRecipientChange}
                />
                <div className="padding-bottom-2x">
                    {recipients.map((recipient) => (
                        <React.Fragment key={recipient.AddressBookEntryId}>
                            <Address
                                className="margin-bottom-2x padding-bottom-2x border-bottom"
                                recipient={recipient}
                                countries={countries}
                                onEdit={handleEditRecipientClicked}
                                onRemove={handleRemoveRecipientClicked}
                            />
                        </React.Fragment>
                    ))}
                </div>
            </>
        );
    }
}

AddressList.defaultProps = {
    recipients: [],
    countries: [],
    handleRemoveRecipientClicked: () => { },
    handleEditRecipientClicked: () => { },
};

AddressList.propTypes = {
    recipients: PropTypes.array,
    countries: PropTypes.array,
    handleEditRecipientClicked: PropTypes.func,
    handleRemoveRecipientClicked: PropTypes.func,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    // console.log('AddressList - newState', newState);
    return {
        toggleState: newState.toggleState,
        recipients: newState.recipients,
        countries: newState.countries,
    };
};

const mapDispatchToProps = (dispatch) => ({
    handleEditRecipientClicked: (recipient, AddressBookEntryId, AddressId) => dispatch(EventDispatcher.handleEditRecipientClicked(
        recipient,
        AddressBookEntryId,
        AddressId,
    )),
    handleRemoveRecipientClicked: (recipient, AddressId, addressType) => dispatch(EventDispatcher.handleRemoveRecipientClicked(
        recipient,
        AddressId,
        addressType,
    )),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AddressList);
